'use strict';
import angular from 'angular';
import './scripts/management.ctrls';

import managementToolsHtmlUrl from './views/managementTools.html';
import statusListHtmlUrl from './views/statusList.html';

angular.module('management', [
    'management.ctrls'
])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('managementTools', {
                parent: 'layout',
                url: '/admin/tools?taskId&orderId&taskStatus',
                templateUrl: managementToolsHtmlUrl,
                controller: 'ManagementToolsController',
            })
            .state('statusList', {
                parent: 'layout',
                url: '/admin/tools/statusList',
                templateUrl: statusListHtmlUrl,
                controller: 'StatusListController',
            })
    }]);